import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { enumNivelDetalle, globalConf } from 'src/GlobalConf';
import { VariablesGlobalesService } from '../variables-globales.service';
import { AMRespuestaGET } from '../../Models/RespuestaGET/AMRespuestaGET';
import { ArticuloDTO } from 'src/app/Models/ApiV2/ArticuloDTO';
import { AMRespuestaPOSTPUT } from 'src/app/Models/RespuestaPOSTPUT/AMRespuestaPOSTPUT';
import { EntidadCodigoStringDTO } from 'src/app/Models/ApiV2/EntidadCodigoStringDTO';
import { MarcaDTO } from 'src/app/Models/ApiV2/MarcaDTO';
import { ModeloDTO } from 'src/app/Models/ApiV2/ModeloDTO';
import { ClienteDTO, ProveedorDTO } from 'src/app/Models/ApiV2/Terceros';

@Injectable({
  providedIn: 'root'
})
export class ErpService {
  private http = inject(HttpClient);
  variablesGlobales = inject(VariablesGlobalesService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

  /**
   * Método para realizar la petición a ALO solicitanto la lista de articulos 
   * @param nivelDetalle "basico", "avanzado" y "ampliado"
   * @param listaParametros filtros para aplicar en la petición para obtener los articulos
   * @returns Lista de los articulos que devuelve ALO
   */
  obtenerArticulosAlo(nivelDetalle: enumNivelDetalle, listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + nivelDetalle + '/' + this.variablesGlobales.empresaActual.GUID_Registro + '/articulos', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto un artículo
* @param nivelDetalle "basico", "avanzado" y "ampliado"
* @param id identificador del artículo del cual queremos obtener sus datos
* @returns Articulo con id coincidente que devuelve ALO
*/
  obtenerArticuloAlo(nivelDetalle: enumNivelDetalle, id: number): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + nivelDetalle + '/' + this.variablesGlobales.empresaActual.GUID_Registro + '/articulos/' + id)
  }

  /**
  * Método para realizar la petición a ALO solicitanto la lista de categorias de articulos
  * @param listaParametros filtros para aplicar en la petición para obtener las categorías
  * @returns Lista de las Categorías de articulos que devuelve ALO
  */
  obtenerCategoriasArticulosAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/categorias/articulos', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de familias de productos
* @param listaParametros filtros para aplicar en la petición para obtener las familias
* @returns Lista de las Familias de productos que devuelve ALO
*/
  obtenerFamiliasArticulosAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/familias', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de marcas de productos
* @param listaParametros filtros para aplicar en la petición para obtener las marcas
* @returns Lista de las marcas de productos que devuelve ALO
*/
  obtenerMarcasArticulosAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/marcas', { params: listaParametros })
  }

  /**
  * Método para realizar la petición a ALO solicitanto la lista de marcas de productos
  * @param listaParametros filtros para aplicar en la petición para obtener las marcas
  * @returns Lista de las marcas de productos que devuelve ALO
  */
  obtenerModelosArticulosAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/modelos', { params: listaParametros })
  }

  /**
   * Método para realizar la petición a ALO solicitanto la lista de clientes 
   * @param nivelDetalle "basico", "avanzado" y "ampliado"
   * @param listaParametros filtros para aplicar en la petición para obtener los clientes
   * @returns Lista de los Clientes que devuelve ALO
   */
  obtenerClientesAlo(nivelDetalle: enumNivelDetalle, listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + nivelDetalle + '/' + this.variablesGlobales.empresaActual.GUID_Registro + '/clientes', { params: listaParametros })
  }

  /**
 * Método para realizar la petición a ALO solicitanto un cliente
 * @param nivelDetalle "basico", "avanzado" y "ampliado"
 * @param id identificador del cliente del cual queremos obtener sus datos
 * @returns Cliente con id coincidente que devuelve ALO
 */
  obtenerClienteAlo(nivelDetalle: enumNivelDetalle, id: number): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + nivelDetalle + '/' + this.variablesGlobales.empresaActual.GUID_Registro + '/clientes/' + id)
  }

  /**
  * Método para realizar la petición a ALO solicitanto la lista de categorias de clientes
  * @param listaParametros filtros para aplicar en la petición para obtener las categorías
  * @returns Lista de las Categorías de clientes que devuelve ALO
  */
  obtenerCategoriasClientesAlo(listaParametros?: HttpParams): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/categorias/clientes', { params: listaParametros })
  }

  /**
   * Método para realizar la petición a ALO para crear un CLIENTE
   * @param cliente
   * @returns AMRespuestaPostPut
   */
  postClienteAlo(cliente: ClienteDTO): Observable<AMRespuestaPOSTPUT> {
    let url: string = globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/clientes';
    var clientesJSON = []
    clientesJSON.push(cliente)
    console.log({ clientesJSON });
    return this.http.post<AMRespuestaPOSTPUT>(url, clientesJSON)
  }

  /**
    * Método para realizar la petición a ALO para MODIFICAR un CLIENTE
    * @param cliente
    * @returns AMRespuestaPostPut
    */
  putClienteAlo(cliente: ClienteDTO): Observable<AMRespuestaPOSTPUT> {
    let url: string = globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/clientes';
    var clientesJSON = []
    clientesJSON.push(cliente)
    console.log({ clientesJSON });
    return this.http.put<AMRespuestaPOSTPUT>(url, clientesJSON)
  }

  /**
  * Método para realizar la petición a ALO solicitanto la lista de clientes 
  * @param nivelDetalle "basico", "avanzado" y "ampliado"
  * @param listaParametros filtros para aplicar en la petición para obtener los clientes
  * @returns Lista de los Clientes que devuelve ALO
  */
  obtenerProveedoresAlo(nivelDetalle: enumNivelDetalle, listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + nivelDetalle + '/' + this.variablesGlobales.empresaActual.GUID_Registro + '/proveedores', { params: listaParametros })
  }

  /**
 * Método para realizar la petición a ALO solicitanto un cliente
 * @param nivelDetalle "basico", "avanzado" y "ampliado"
 * @param id identificador del cliente del cual queremos obtener sus datos
 * @returns Cliente con id coincidente que devuelve ALO
 */
  obtenerProveedorAlo(nivelDetalle: enumNivelDetalle, id: number): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + nivelDetalle + '/' + this.variablesGlobales.empresaActual.GUID_Registro + '/proveedores/' + id)
  }

  /**
  * Método para realizar la petición a ALO solicitanto la lista de categorias de clientes
  * @param listaParametros filtros para aplicar en la petición para obtener las categorías
  * @returns Lista de las Categorías de clientes que devuelve ALO
  */
  obtenerCategoriasProveedoresAlo(listaParametros?: HttpParams): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/categorias/proveedores', { params: listaParametros })
  }

  /**
   * Método para realizar la petición a ALO para crear un PROVEEDOR
   * @param proveedor
   * @returns AMRespuestaPostPut
   */
  postProveedorAlo(proveedor: ProveedorDTO): Observable<AMRespuestaPOSTPUT> {
    let url: string = globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/proveedores';
    var proveedoresJSON = []
    proveedoresJSON.push(proveedor)
    console.log({ proveedoresJSON });
    return this.http.post<AMRespuestaPOSTPUT>(url, proveedoresJSON)
  }

   /**
   * Método para realizar la petición a ALO para MODIFICAR un PROVEEDOR
   * @param proveedor
   * @returns AMRespuestaPostPut
   */
   putProveedorAlo(proveedor: ProveedorDTO): Observable<AMRespuestaPOSTPUT> {
    let url: string = globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/proveedores';
    var proveedoresJSON = []
    proveedoresJSON.push(proveedor)
    console.log({ proveedoresJSON });
    return this.http.put<AMRespuestaPOSTPUT>(url, proveedoresJSON)
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de vendedores
* @param nivelDetalle nivel de detalle. BASICO, AVANZADO
* @param listaParametros filtros para aplicar en la petición para obtener la lista de vendedores
* @returns Lista de vendedores que devuelve ALO
*/
  obtenerVendedoresAlo(nivelDetalle: string, listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + nivelDetalle + '/' + this.variablesGlobales.empresaActual.GUID_Registro + '/vendedores', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto un vendedor
* @param nivelDetalle nivel de detalle. BASICO, AVANZADO
* @returns Información del vendedor que devuelve ALO
*/
  obtenerVendedorAlo(nivelDetalle: string, id: number): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + nivelDetalle + '/' + this.variablesGlobales.empresaActual.GUID_Registro + '/vendedores/' + id)
  }
  /**
 * Método para realizar la petición a ALO solicitanto la lista de rutas
 * @param listaParametros filtros para aplicar en la petición para obtener las rutas
 * @returns Lista de las rutas que devuelve ALO
 */
  obtenerRutasAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/rutas', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de zonas
* @param listaParametros filtros para aplicar en la petición para obtener las zonas
* @returns Lista de las zonas que devuelve ALO
*/
  obtenerZonasAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/zonas', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de formas de pago
* @param listaParametros filtros para aplicar en la petición para obtener las formas de pago
* @returns Lista de las formas de pago que devuelve ALO
*/
  obtenerFormasPagoAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/formaspago', { params: listaParametros })
  }

  /**
  * Método para crear una lista de marcas en ALO
  * @param marcas Array de objetos MarcaDTO
  * @returns Observable con la respuesta del servidor
  */
  crearMarcas(marcas: MarcaDTO[]): Observable<any> {
    const url = `${globalConf.url_api_erp}api/v2/erp/${this.variablesGlobales.empresaActual.GUID_Registro}/marcas`;

    // Cabeceras para la petición
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realiza la petición POST con los datos
    return this.http.post<any>(url, marcas, { headers });
  }

  /**
   * Crear tarifas de precios
   * @param empresaGUID GUID de la empresa
   * @param tarifas Array de tarifas a enviar
   * @returns Observable con la respuesta del servidor
   */
  crearTarifasPrecios(tarifas: any[]): Observable<any> {
    const url = `${globalConf.url_api_erp}api/v2/erp/${this.variablesGlobales.empresaActual.GUID_Registro}/tarifas/precios`;
    const headers = { 'Content-Type': 'application/json' };

    return this.http.post<any>(url, tarifas, { headers });
  }

  crearTarifasDescuentos(tarifas: any[]): Observable<any> {
    const url = `${globalConf.url_api_erp}api/v2/erp/${this.variablesGlobales.empresaActual.GUID_Registro}/tarifas/descuentos`;
    const headers = { 'Content-Type': 'application/json' };

    return this.http.post<any>(url, tarifas, { headers });
  }

  /**
   * Método para crear un nuevo artículo
   * @param articulo Datos del artículo a enviar
   * @returns Observable con la respuesta del servidor
   */
  crearArticulo(nuevoArticulo: ArticuloDTO[]): Observable<any> {
    const url = `${globalConf.url_api_erp}api/v2/erp/${this.variablesGlobales.empresaActual.GUID_Registro}/articulos`;

    // Cabeceras para la petición
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realiza la petición POST con los datos
    return this.http.post<any>(url, nuevoArticulo, { headers });
  }

  /**
  * Método para crear una lista de modelos en ALO
  * @param modelos Array de objetos ModeloDTO
  * @returns Observable con la respuesta del servidor
  */
  crearModelos(modelos: ModeloDTO[]): Observable<any> {
    const url = `${globalConf.url_api_erp}api/v2/erp/${this.variablesGlobales.empresaActual.GUID_Registro}/modelos`;

    // Cabeceras para la petición
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realiza la petición POST con los datos
    return this.http.post<any>(url, modelos, { headers });
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de tarifas de precio
* @param listaParametros filtros para aplicar en la petición para obtener la lista de tarifas de precio
* @returns Lista de tarifas de precio que devuelve ALO
*/
  obtenerTipoTarifaAlo(tipoTarifa: string, listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/tipostarifas/' + tipoTarifa, { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de paises
* @param listaParametros filtros para aplicar en la petición para obtener la lista de paises
* @returns Lista de paises que devuelve ALO
*/
  obtenerPaisAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/paises/', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de codigos postales
* @param listaParametros filtros para aplicar en la petición para obtener la lista de codigos postales
* @returns Lista de codigos postales que devuelve ALO
*/
  obtenerCodigosPostalesAlo(idPais: number, listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/codigospostales/' + idPais, { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de almacenes
* @param listaParametros filtros para aplicar en la petición para obtener la lista de almacenes
* @returns Lista de almacenes que devuelve ALO
*/
  obtenerAlmacenesAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/almacenes/', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de lotes
* @param listaParametros filtros para aplicar en la petición para obtener la lista de lotes
* @returns Lista de almacenes que devuelve ALO
*/
  obtenerLotesAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/lotes/', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de lotes
* @param listaParametros filtros para aplicar en la petición para obtener la lista de lotes
* @returns Lista de almacenes que devuelve ALO
*/
  obtenerTiposIVAAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/tiposiva', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de tipos de retenciones
* @param listaParametros filtros para aplicar en la petición para obtener la lista de tipos de retenciones
* @returns Lista de tipos de retenciones que devuelve ALO
*/
  obtenerTiposRetencionServiciosAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/tiposRetenciones', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de sucursales
* @param listaParametros filtros para aplicar en la petición para obtener la lista de sucursales
* @returns Lista de sucursales que devuelve ALO
*/
  obtenerSucursalesAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/sucursales/', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de cuentas tesorería
* @param listaParametros filtros para aplicar en la petición para obtener la lista de cuentas de tesorería
* @returns Lista de cuentas de tesorería que devuelve ALO
*/
  obtenerCuentasTesoreriaAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/cuentastesoreria/', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de terminales tesorería
* @param listaParametros filtros para aplicar en la petición para obtener la lista de terminales de tesorería
* @returns Lista de terminales de tesorería que devuelve ALO
*/
  obtenerTerminalesTesoreriaAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/terminalestesoreria/', { params: listaParametros })
  }

  /**
   * Método para realizar la petición a ALO el enlace de descarga de un documento
   * @param idDocumento id del docuemnto del cual queremos obtener su enlace de descarga
   * @returns AMRespuestaGET
   */
  getDescargaDocumento(idDocumento: number): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/erp/' + this.variablesGlobales.empresaActual.GUID_Registro + '/documentos/descargardocumento/' + idDocumento);
  }

  guardarImagenFicherosRegistros(body): Observable<AMRespuestaPOSTPUT> {
    console.log("bodyarticulo", body)
    return this.http.post(globalConf.url_api_erp + 'api/v2/administracion/' + this.variablesGlobales.empresaActual.GUID_Registro + '/ficherosregistros', body) as Observable<AMRespuestaPOSTPUT>

  }

  obtenerAspecto(): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/' + this.variablesGlobales.empresaActual.GUID_Registro + '/parametros?grupos=ASPECTO')
  }
}
